export default "__VITE_ASSET__CGq9i1AN__$_?component__"